import styles from "./styles.module.scss";
import ProgressArrow from "../_basic/ProgressArrow";
import SlideNavigation, { OnNavigationType } from "../_basic/SlideNavigation";
import { SingleActionSlideType } from "../../../types/singleActionSlide";

interface SingleActionSlideProps {
  data: SingleActionSlideType;
  onNavigation: OnNavigationType;
}

const icons = [
  "/icons/check.svg",
  "/icons/check.svg",
  "/icons/camera.svg",
  "/icons/calendar.svg",
];

const SingleActionSlide: React.FC<SingleActionSlideProps> = ({
  data,
  onNavigation,
}) => {
  return (
    <div className={styles.mainContainer}>
      {data.title && <div className={styles.title}>{data.title}</div>}
      <div className={`${styles.content}`}>
        {data.contentHeader && (
          <div className={styles.contentHeader}>{data.contentHeader}</div>
        )}

        {data.progressIndicator && (
          <div className={styles.progressIndicatorContainer}>
            {Object.keys(data.progressIndicator).map((objKey, index) => {
              if (data.progressIndicator != null) {
                const typedKey = objKey as keyof typeof data.progressIndicator;
                const obj = data.progressIndicator[typedKey];
                return (
                  <div key={objKey} className={styles.progressIndicatorItem}>
                    <ProgressArrow
                      size={100}
                      isFirst={index === 0}
                      isComplete={index <= 1}
                      imageUrl={icons[index]}
                    />
                    <p>{obj}</p>
                  </div>
                );
              }
              return <div></div>;
            })}
          </div>
        )}

        {data.buttonLabel && (
          <button className={styles.button}>{data.buttonLabel}</button>
        )}
      </div>
      <SlideNavigation onNavigation={onNavigation} />
    </div>
  );
};

export default SingleActionSlide;
